import { GetParameters } from '../../utilities/get_parameters';

export const checkForTyreDimensionGETParams = (getParameters = new GetParameters()) => (
    getParameters.has('width')
    || getParameters.has('height')
    || getParameters.has('diameter')
);
